/* exp-pdp-beef-v1.js — A/B pdp_beef_v2 — reorganizare oferte WideBundle
   Pentru fiecare ofertă:
     - Ofertele cu GRATIS (N+M): titlul devine "{qty} - {text emoțional}",
       iar badge-ul de colț devine "{nr gratis} GRATIS 🎁".
     - Linia "Salvezi X%" devine "{preț/pungă} (salvezi {economie})";
       la oferta de 1 pungă doar "(salvezi {economie})" (fără preț/pungă dublat).
   Datele originale sunt captate o singură dată per node în atribute data-*,
   ca reaplicarea să fie stabilă la re-randarea WideBundle.
   Rulează DOAR pe varianta B. */
(function () {
  // Sirurile vizibile vin din locales/ prin window.PDP_B_I18N (injectat in
  // templates/product.json). Fallback pe romana daca injectia lipseste, ca
  // blocul sa nu ramana gol.
  var T = window.PDP_B_I18N || {};
  var T_FREE = T.free || 'GRATIS \uD83C\uDF81';
  var T_SAVE = T.save || 'salvezi';
  var T_UNIT = T.unit || 'pung\u0103';

  // Gating pe pdp_selector_v1 (A/B din 2026-08-14), NU pe pdp_beef_v2: acesta din urmă e
  // static "B" în layout și servește restul pachetului B pe ambele arme. Arma A a testului de
  // selector = acest fișier iese aici, deci WideBundle rămâne exact cum îl randează aplicația.
  if (document.documentElement.getAttribute('data-exp-pdp_selector_v1') !== 'B') return;

  function parseMoney(txt) {
    if (!txt) return NaN;
    var m = (txt.match(/[0-9.,]+/) || [''])[0];
    if (!m) return NaN;
    m = m.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(m);
    return isNaN(v) ? NaN : v;
  }
  // "4+1"->5, "7+2"->9, "13+4"->17, altfel primul număr.
  function parseQty(title) {
    if (!title) return NaN;
    var plus = title.match(/(\d+)\s*\+\s*(\d+)/);
    if (plus) return parseInt(plus[1], 10) + parseInt(plus[2], 10);
    // Titluri tip pachet mixt ("4 Vită Original + 4 Vită American + 2 Pui & 2 MaxiSticks Gratis"):
    // pungile = suma tuturor cantităților (inclusiv cele gratis), nu doar primul număr.
    var nums = title.match(/\d+(?!\d)(?!\s*(?:g|kg|%|lei|ron|eur)\b)/gi);
    if (!nums) return NaN;
    return nums.reduce(function (s, n) { return s + parseInt(n, 10); }, 0);
  }
  // nr de pungi gratis = al doilea număr din "N+M"; 0 dacă nu există.
  function parseGratis(title) {
    var plus = title && title.match(/(\d+)\s*\+\s*(\d+)/);
    return plus ? parseInt(plus[2], 10) : 0;
  }

  function apply() {
    var opts = document.querySelectorAll('#new-form .new-form-option');
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var titleEl = opt.querySelector('.title-variant');
      var cornerEl = opt.querySelector('.corner-offer');
      var priceEl = opt.querySelector('.first-price-WB');
      var ecoEl = opt.querySelector('.economic-wb');
      if (!titleEl || !priceEl || !ecoEl) continue;

      // 1) Captează datele de bază o singură dată per node (din starea originală).
      if (!opt.getAttribute('data-wb-init')) {
        var q0 = parseQty(titleEl.textContent);
        if (isNaN(q0)) continue; // titlul încă nu e randat
        opt.setAttribute('data-wb-qty', q0);
        opt.setAttribute('data-wb-gratis', parseGratis(titleEl.textContent));
        opt.setAttribute('data-wb-emotional', cornerEl ? cornerEl.textContent.trim() : '');
        opt.setAttribute('data-wb-init', '1');
      }
      var qty = parseInt(opt.getAttribute('data-wb-qty'), 10);
      var gratis = parseInt(opt.getAttribute('data-wb-gratis'), 10) || 0;
      var emotional = opt.getAttribute('data-wb-emotional') || '';

      // 2) Economia (din span-ul original al WideBundle sau din valoarea stocată).
      var savingSpan = ecoEl.querySelector('.span-economic-wb');
      var saving = savingSpan ? savingSpan.textContent.trim() : opt.getAttribute('data-wb-saving');
      if (saving) opt.setAttribute('data-wb-saving', saving);

      // 3) Preț/pungă.
      var price = parseMoney(priceEl.textContent);
      var perBag = (!isNaN(price) && qty > 0) ? (price / qty).toFixed(2).replace('.', ',') : null;

      // --- Transformări (idempotente) ---
      // Ofertele cu GRATIS: titlu "{qty} - {text}" + badge "{gratis} GRATIS 🎁".
      if (gratis > 0 && emotional) {
        var newTitle = qty + ' - ' + emotional;
        if (titleEl.textContent !== newTitle) titleEl.textContent = newTitle;
        if (cornerEl) {
          var newCorner = gratis + ' ' + T_FREE;
          if (cornerEl.textContent !== newCorner) cornerEl.textContent = newCorner;
        }
      }

      // economic-wb: la 1 pungă doar "(salvezi X)"; altfel "preț/pungă (salvezi X)".
      if (saving) {
        var newEco = (qty === 1 || !perBag)
          ? ('(' + T_SAVE + ' ' + saving + ')')
          : (perBag + '/' + T_UNIT + ' (' + T_SAVE + ' ' + saving + ')');
        if (ecoEl.getAttribute('data-ppb') !== newEco) {
          ecoEl.textContent = newEco;
          ecoEl.setAttribute('data-ppb', newEco);
          ecoEl.style.display = 'block';
        }
      }
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; apply(); }, 16);
  }
  function boot() {
    apply();
    try {
      var mo = new MutationObserver(schedule);
      mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    var tries = 0;
    var iv = setInterval(function () { apply(); if (++tries > 24) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
